<script setup lang="ts">
interface IconArrowRightProps {
  color?: string
}

defineProps({
  color: null
})
</script>

<template>
  <svg
    id="eSg3hrAiUxE1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
  >
    <circle
      r="9"
      transform="translate(12 12)"
      opacity="0.3"
      fill="none"
      stroke="#fff"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="56.55"
    /><g
      id="eSg3hrAiUxE3_tr"
      transform="translate(12,12) rotate(-45)"
    ><circle
      id="eSg3hrAiUxE3"
      r="9"
      transform="translate(0,0)"
      fill="none"
      stroke="#fff"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dashoffset="56.54"
      stroke-dasharray="56.55"
    /></g></svg>
</template>

<style lang="scss" scoped>
#eSg3hrAiUxE3_tr {
  animation: eSg3hrAiUxE3_tr__tr 2000ms linear infinite normal forwards;
}
@keyframes eSg3hrAiUxE3_tr__tr {
  0% {
    transform: translate(12px,12px) rotate(-45deg);
  }
  100% {
    transform: translate(12px,12px) rotate(675deg)
  }
}

#eSg3hrAiUxE3 {
  animation: eSg3hrAiUxE3_s_do 2000ms linear infinite normal forwards;
}
@keyframes eSg3hrAiUxE3_s_do {
  0% { stroke-dashoffset: 56.54 }
  20% { stroke-dashoffset: 33.924 }
  100% { stroke-dashoffset: 56.53 }
}
</style>
